import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

import { OverlayEventDetail } from '@ionic/core';
import { AlertController, ModalController } from '@ionic/angular';

import { GoogleMap, Marker } from '@capacitor/google-maps';
import { Geolocation } from '@capacitor/geolocation';
import { environment } from 'src/environments/environment';

import { AjaxService } from '../ajax.service';
import { GlobalService } from '../global.service';
import { PlatformMapsService } from '../services/platform-maps.service';
import { ScanCameraPage } from '../scan-camera/scan-camera.page';

interface ApiResponse {
    login: boolean;
    txt: any;
    orders?: any;
    des?: string;
    eenh?: string;
}

@Component({
    selector: 'app-objecten',
    templateUrl: './objecten.page.html',
    styleUrls: ['./objecten.page.scss'],
    standalone: false
})
export class ObjectenPage implements OnInit {
    inpObj = '';
    objlist: any[] = [];
    currObjNr = '';
    currObj = [];
    scanCamera = false;

    dlgNwOrder = false;
    ordOmsch = '';
    ordType = '-';
    ordNr = '';
    orders: any[] = [];

    objs: any[] = [];
    objOmschrn: string[] = [];
    markers: Marker[] = [];
    markList: any;

    @ViewChild('googlemap') mapRef: ElementRef;
    gmap: GoogleMap;
    objMarker: string = '';
    latitude = 0; // 51.2777107;
    longitude = 0; //5.7496367;
    zoom = 16;

    constructor(
        public router: Router,
        private route: ActivatedRoute,
        public global: GlobalService,
        public alertController: AlertController,
        public http: HttpClient,
        public modalController: ModalController,
        private snackBar: MatSnackBar,
        private ajax: AjaxService,
        private platformMaps: PlatformMapsService,
    ) { }

    ngOnInit() {
        if (!this.global.isLoggedIn) {
            this.router.navigateByUrl('login');
        }
    }

    ionViewDidEnter() {
        if (!this.objlist.length && this.currObjNr && this.currObj) {
            this.showObj();
        }
    }

    ngAfterViewInit() {
        this.route.params.subscribe(params => {
            if (params.objnr) {
                this.click_obj(params.objnr);
            }
        });
    }

    async doScan() {
        if (!await this.global.startCamera()) {
            return;
        }
        this.scanCamera = true;
        const myDlg = await this.modalController.create({
            component: ScanCameraPage,
        });
        myDlg.onDidDismiss()
            .then((dataPar: OverlayEventDetail) => {
                this.scanCamera = false;
                if (dataPar.data.code) {
                    this.inpObj = dataPar.data.code;
                    this.currObjNr = this.inpObj;
                    this.currObj = [];
                    this.objlist = [];
                    this.showObj();

                }
            });
        return await myDlg.present();
    }

    click_obj(nwObj) {
        this.gmap = null; // noodzakelijk op IOS, anders komt hij niet in beeld na hide/show
        this.inpObj = nwObj;
        this.currObjNr = nwObj;
        this.currObj = [];
        this.objlist = [];
        this.showObj();
    }

    click_proj(nwProj) {
        localStorage.setItem('lastProjNr', nwProj);
        this.router.navigateByUrl('orders');
    }

    onChange(nwObj) {
        this.ajax.get('objList', { req: nwObj })
            .then((data: any) => {
                this.objlist = data.txt;
                this.ordNr = '';
                if (
                    data.txt.length === 1
                    && data.txt[0].nr.toLowerCase() === nwObj.toLowerCase()
                ) {
                    this.click_obj(data.txt[0].nr);
                }
            }
            );
    }

    showObj() {
        // doet details this.inpObj weergeven
        this.ajax.get('objectDetail', { req: this.currObjNr })
        .then((data: any) => {
            console.log(data.txt);
            this.currObj = data.txt;
            this.orders = data.orders;
            console.log('set gmap to' , data.lat, data.lon);
            if (data.lat && data.lon) {
                this.latitude = parseFloat(data.lat);
                this.longitude = parseFloat(data.lon);
            } else {
                this.latitude = 0;
                this.longitude = 0;
            }
            if (!this.gmap) {
                Promise.all([
                    this.initMap(),
                ]).then(() => {
                    this.showObjOnMap(data.lat, data.lon);
                });
            } else {
                this.showObjOnMap(data.lat, data.lon);
            }
        });
    }

    showObjOnMap(lat, lon) {
        if (this.gmap) {
            if (this.objMarker) {
                this.gmap.removeMarker(this.objMarker);
            }
            this.gmap.addMarker({
                coordinate: {
                    lat: parseFloat(lat),
                    lng: parseFloat(lon)
                }
            }).then((marker) => {
                this.objMarker = marker;
            });
            this.gmap.setCamera({
                coordinate: {
                    lat: parseFloat(lat),
                    lng: parseFloat(lon)
                },
                zoom: this.zoom
            });
        } else {
            console.log('gmap not ready');
        }
    }

    async doNwOrder() {
        this.ordOmsch = '';
        this.ordType = '-';
        this.dlgNwOrder = true;
    }

    doNwOrderIns() {
        this.ajax.get('nwOrder', {
            proj: this.currObjNr,
            req: this.ordOmsch,
            qty: this.ordType
        })
            .then((data: any) => {
                console.log(data.txt);
                // this.ordNr = data.txt;
                this.dlgNwOrder = false;
                this.showObj();
                this.click_proj(data.txt);
            }
            );

    }

    mapsUrl(adr: string) {
        return 'https://www.google.com/maps/dir/?api=1&destination='
            + adr.replace(/(?:\r\n|\r|\n)/g, ',');
    }

    async initMap() {
        //await this.getLocation();
        //const h = this.platform.height();
        if (!this.gmap) {
            await GoogleMap.create({
                id: 'my-objmap', // Unique identifier for this map instance
                element: this.mapRef.nativeElement, // reference to the capacitor-google-map element
                apiKey: this.platformMaps.getMapsApiKey(), // Platform-specific Google Maps API Key
                forceCreate: true,
                config: {
                  center: {
                    // The initial position to be rendered by the map
                    lat: this.latitude,
                    lng: this.longitude,
                  },
                  zoom: this.zoom, // The initial zoom level to be rendered by the map
                },
            }).then((map) => {
                if (map) {
                    console.log('map created', map);
                    this.gmap = map;
                    this.gmap.enableCurrentLocation(true);
                } else {
                    console.log('map not created');
                }
            });
        }
    }

    async getLocation() {
        try {
            const position = await Geolocation.getCurrentPosition( { enableHighAccuracy: true } );
        }
        catch(e) {
            console.log('Geen positie te verkrijgen', e);
        }
    }

    public confirmButtons = [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'OK',
          role: 'confirm',
        },
    ];
    async doChObjPos(ev) {
        console.log('doChObjPos');
        if (ev.detail.role === 'confirm') {
            let myLat = 0;
            let myLon = 0;
            try {
                const position = await Geolocation.getCurrentPosition( { enableHighAccuracy: true } );
                myLat = position.coords.latitude;
                myLon = position.coords.longitude;
            }
            catch(e) {
                console.log('Geen positie te verkrijgen', e);
                this.snackBar.open('Kon uw positie niet bepalen!', 'OK', {
                    duration: 3000
                });
            }
            if (!myLat && !myLon) {
                this.snackBar.open('Kon uw positie niet bepalen!', 'OK', {
                    duration: 3000
                });
                return;
            }
            this.ajax.get('setObjPos', {
                obj: this.currObjNr,
                lat: myLat,
                lon: myLon
            }).then((data: any) => {
                console.log('setObjPos', data);
                if (data.ok) {
                    this.snackBar.open('Positie aangepast', 'OK', {
                        duration: 3000
                    });
                } else {
                    this.snackBar.open('Positie NIET aangepast', 'OK', {
                        duration: 3000
                    });
                }
                this.showObj();
            });
        } else { // cancel pressed
            this.snackBar.open('Positie NIET aangepast', 'OK', {
                duration: 3000
            });
        }
    }
}
